<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      v-for="company in companies" :key="company.name"
    >
      <product-card header-animation="false">
        <h4 slot="title" class="title">
          {{ company.company.company_name }}
          <div class="files-display-item" v-if="company.files.length > 0">
              <div class="fdi-wrap">
                <img class="company_logo" :src="company.files[0].url" />
              </div>
            </div>
        </h4>
        <img class="img" slot="imageMedia" :src="product2" />
        <div slot="description" class="card-description">
          <template v-if="company.address">
            Company Address: {{ company.address.street_address }}; {{company.address.city}}, {{company.address.state}} {{company.address.zip_code}} <br />
          </template>
          Company Email: {{ company.company.company_email_address }} <br />
          Company Phone: {{ company.company.office_phone }}
        </div>
        <template slot="footer">
          <div class="price" @click="editCompany(company.company.id)">
            <h4><md-icon>create</md-icon></h4>
          </div>
        </template>
      </product-card>
    </div>
  </div>
</template>

<script>
import {
  ProductCard
} from "@/components";
import api from "@/api";

export default {
  components: {
    ProductCard
  },
  data() {
    return {
      product1: "./img/card-2.jpg",
      product2: "./img/card-3.jpg",
      product3: "./img/card-1.jpg",
      seq2: 0,
      companies: [],
    };
  },
  created() {
    api.getCompanies().then((response) => {
      this.companies = response.data.companies
    })
  },
  methods: {
    editCompany(id){
      console.log(id)
      this.$router.push(`/editcompany/${id}`)
    },
  }
};
</script>

<style lang="scss">
  .md-layout {
    width: 80%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
  }
  .unstarted-div {
    border-bottom: 2px solid #2274A5;
    h3 {
      font-weight: 500;
      color: #033860;
    }
  }
  .price {
    cursor: pointer;
  }
  .company_logo{
    width: 100px !important;
  }
</style>
